// extracted by mini-css-extract-plugin
export default {"title":"Item_title__kJwXe","section":"Item_section__Lkra2"};